"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
exports.defaultOptions = {
    width: 600,
    height: 400,
};
//# sourceMappingURL=active-placeholder.js.map